module.exports = __webpack_public_path__ + "static/media/photo_blacka73b9cc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/photo_black.svg
// module id = 1261
// module chunks = 0